(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pc-main"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(root) {
      if (root.dataset.pcMainReady) return;
      root.dataset.pcMainReady = '1';

      var stage  = root.querySelector('[data-pc-stage]');
      var slides = root.querySelectorAll('[data-pc-slide]');
      var thumbs = root.querySelectorAll('[data-pc-thumb]');
      var dotWrap = root.querySelector('[data-pc-dots]');
      var buy    = root.querySelector('[data-pc-buy]');
      var totalEl = root.querySelector('[data-pc-total]');
      var wasEl   = root.querySelector('[data-pc-was]');

      /* ---- gallery ---- */
      var dots = [];
      if (dotWrap && slides.length > 1) {
        for (var i = 0; i < slides.length; i++) {
          var d = document.createElement('button');
          d.type = 'button';
          d.className = 'pc-main__dot' + (i === 0 ? ' is-active' : '');
          d.setAttribute('aria-label', 'Imagen ' + (i + 1));
          (function (n) { d.addEventListener('click', function () { go(n); }); })(i);
          dotWrap.appendChild(d);
          dots.push(d);
        }
      }

      function paint(n) {
        for (var i = 0; i < dots.length; i++) dots[i].classList.toggle('is-active', i === n);
        for (var j = 0; j < thumbs.length; j++) thumbs[j].classList.toggle('is-active', j === n);
        /* Keep the active thumbnail in view without scrolling the page. */
        var tb = thumbs[n], strip = tb && tb.parentNode;
        if (strip && strip.scrollWidth > strip.clientWidth) {
          var l = tb.offsetLeft - strip.offsetLeft, r = l + tb.offsetWidth;
          if (l < strip.scrollLeft) strip.scrollTo({ left: l, behavior: 'smooth' });
          else if (r > strip.scrollLeft + strip.clientWidth) strip.scrollTo({ left: r - strip.clientWidth, behavior: 'smooth' });
        }
      }
      function go(n) {
        if (!stage || !slides[n]) return;
        stage.scrollTo({ left: slides[n].offsetLeft - stage.offsetLeft, behavior: 'smooth' });
        paint(n);
      }
      for (var t = 0; t < thumbs.length; t++) {
        (function (btn) {
          btn.addEventListener('click', function () { go(Number(btn.getAttribute('data-pc-thumb'))); });
        })(thumbs[t]);
      }
      if (stage) {
        var tick = false;
        stage.addEventListener('scroll', function () {
          if (tick) return;
          tick = true;
          requestAnimationFrame(function () {
            tick = false;
            var mid = stage.scrollLeft + stage.clientWidth / 2, best = 0, bd = Infinity;
            for (var i = 0; i < slides.length; i++) {
              var c = slides[i].offsetLeft - stage.offsetLeft + slides[i].offsetWidth / 2;
              var dd = Math.abs(c - mid);
              if (dd < bd) { bd = dd; best = i; }
            }
            paint(best);
          });
        }, { passive: true });
      }

      /* ---- size ---- */
      var sizes = root.querySelectorAll('[data-pc-size]');
      for (var s = 0; s < sizes.length; s++) {
        (function (btn) {
          btn.addEventListener('click', function () {
            if (btn.disabled) return;
            for (var k = 0; k < sizes.length; k++) {
              sizes[k].classList.remove('is-active');
              sizes[k].setAttribute('aria-checked', 'false');
            }
            btn.classList.add('is-active');
            btn.setAttribute('aria-checked', 'true');
            if (buy) buy.setAttribute('data-variant', btn.getAttribute('data-pc-size'));
          });
        })(sizes[s]);
      }

      /* ---- tiers ---- */
      var tiers = root.querySelectorAll('[data-pc-tier]');
      function syncTiers() {
        var chosen = null;
        for (var i = 0; i < tiers.length; i++) {
          var lbl = tiers[i].closest('.pc-main__tier');
          if (lbl) lbl.classList.toggle('is-active', tiers[i].checked);
          if (tiers[i].checked) chosen = tiers[i];
        }
        if (chosen) {
          if (totalEl) totalEl.textContent = chosen.getAttribute('data-price') || '';
          if (wasEl)   wasEl.textContent   = chosen.getAttribute('data-compare') || '';
        }
      }
      for (var y = 0; y < tiers.length; y++) tiers[y].addEventListener('change', syncTiers);
      /* ?pack=N (from the advertorial's bundle cards) pre-selects that tier. */
      var pack = null;
      try { pack = new URLSearchParams(location.search).get('pack'); } catch (e) {}
      if (pack) for (var p = 0; p < tiers.length; p++) if (tiers[p].value === pack) tiers[p].checked = true;
      syncTiers();

      /* ---- buy ---- */
      if (buy) {
        buy.addEventListener('click', function () {
          var id = buy.getAttribute('data-variant');
          if (!id) return;
          var qty = 1;
          for (var i = 0; i < tiers.length; i++) if (tiers[i].checked) qty = Number(tiers[i].value) || 1;
          if (buy.dataset.busy) return;
          buy.dataset.busy = '1';
          buy.setAttribute('data-label', buy.innerHTML);
          buy.classList.add('is-busy');
          buy.textContent = 'Abriendo pago seguro…';
          /* One request, then checkout. update.js sets this variant's quantity
             outright (no clear + add, so a second click never stacks packs).
             Measured faster than a /cart/<id>:<qty> permalink, whose server-side
             redirect chain took ~3.5s to reach checkout vs ~1s for this. */
          var updates = {}; updates[id] = qty;
          fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ updates: updates })
          })
            .then(function (r) { if (!r.ok) throw new Error('update failed'); window.location.href = '/checkout'; })
            .catch(function () { window.location.href = '/cart/' + id + ':' + qty; });
        });
      }
    }

    window.addEventListener('pageshow', function () {
      var stuck = document.querySelectorAll('.pc-main__atc.is-busy');
      for (var i = 0; i < stuck.length; i++) {
        if (stuck[i].getAttribute('data-label')) stuck[i].innerHTML = stuck[i].getAttribute('data-label');
        stuck[i].classList.remove('is-busy');
        delete stuck[i].dataset.busy;
      }
    });

    function boot() {
      var all = document.querySelectorAll('.pc-main');
      for (var i = 0; i < all.length; i++) init(all[i]);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
    else boot();
    document.addEventListener('shopify:section:load', boot);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pc-offer"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pc-add]');
    if (!btn) return;

    var id = btn.getAttribute('data-variant');
    var qty = parseInt(btn.getAttribute('data-qty'), 10) || 1;
    if (!id) return;

    e.preventDefault();
    if (btn.dataset.busy) return;
    btn.dataset.busy = '1';
    var label = btn.textContent;
    btn.textContent = 'Añadiendo…';

    // Clear first: /cart/add.js appends, so a second click would stack tiers.
    fetch('/cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } })
      .then(function () {
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: qty }] })
        });
      })
      .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
      .then(function () { window.location.href = '/checkout'; })
      .catch(function () {
        btn.textContent = label;
        delete btn.dataset.busy;
        window.location.href = '/cart';
      });
  });

  } catch(e) { console.error(e); }
})();
})();
